export const VALUE_TYPE_OPTIONS = [
  { label: "Percentage (%)", value: "P" },
  { label: "Flat Amount (₹)", value: "A" },
];

export const CALC_TYPE_OPTIONS = [
  { label: "BaseFare", value: "BaseFare" },
  { label: "TotalFare", value: "TotalFare" },
  { label: "WithAddCharge", value: "WithAddCharge" },
  { label: "None", value: "None" }
];

export const BOOKING_TYPE_OPTIONS = [
  { label: "MobileApp", value: "MobileApp" },
  { label: "DriverApp", value: "DriverApp" },
  { label: "Website", value: "Website" },
  { label: "PartnerApi", value: "PartnerApi" },
  { label: "CustomerService", value: "CustomerService" },
  { label: "IRCTC", value: "IRCTC" },
  { label: "BookingWeb", value: "BookingWeb" },
  { label: "JustDial", value: "JustDial" },
  { label: "Integrator", value: "Integrator" },
  { label: "AirportBooking", value: "AirportBooking" },
  { label: "City", value: "City" },
  { label: "CRON", value: "CRON" },
  { label: "All", value: "All" },
  { label: "Others", value: "Others" },
  { label: "CallCenter", value: "CallCenter" },
];
